import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

export const Footer = () => (
  <footer className="bg-[#0A3B32] text-slate-200 mt-24" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-12 gap-10">
      <div className="md:col-span-5">
        <div className="flex items-center gap-2 font-heading text-2xl font-bold text-white">
          <span className="inline-flex w-9 h-9 rounded-lg bg-[#C85A40] items-center justify-center font-heading text-lg font-bold text-white">
            B
          </span>
          BIOMAC
        </div>
        <p className="mt-4 text-slate-300 max-w-md leading-relaxed">
          India's job-oriented coaching center for medical devices. We help graduates and diploma
          students root their career into the fast-growing biomedical industry.
        </p>
      </div>

      <div className="md:col-span-3">
        <p className="font-heading text-white font-semibold mb-4">Quick Links</p>
        <ul className="space-y-2 text-sm">
          {["About", "Courses", "Placements", "Gallery", "Contact"].map((x) => (
            <li key={x}>
              <Link
                to={`/${x.toLowerCase()}`}
                className="text-slate-300 hover:text-[#C85A40] transition-colors"
                data-testid={`footer-link-${x.toLowerCase()}`}
              >
                {x}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="md:col-span-4">
        <p className="font-heading text-white font-semibold mb-4">Reach BIOMAC</p>
        <ul className="space-y-3 text-sm">
          <li className="flex items-start gap-3">
            <Mail size={18} className="mt-0.5 text-[#C85A40]" />
            <a href="mailto:biomacindiab@gmail.com" className="hover:text-white">biomacindiab@gmail.com</a>
          </li>
          <li className="flex items-start gap-3">
            <Phone size={18} className="mt-0.5 text-[#C85A40]" />
            <a href="tel:+918466864527" className="hover:text-white" data-testid="footer-phone">+91 84668 64527</a>
          </li>
          <li className="flex items-start gap-3">
            <MapPin size={18} className="mt-0.5 text-[#C85A40]" />
            <span>BIOMAC Institute · Vijayawada / Tirupati · India</span>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between items-center text-xs text-slate-400">
        <p>© {new Date().getFullYear()} BIOMAC Institute. All rights reserved.</p>
        <p>
          <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-white">
            Admin Login
          </Link>
        </p>
      </div>
    </div>
  </footer>
);
